import { DateTime } from "luxon";
import { FullSyncableServiceBase } from "./sync.service";
import { Injectable } from "@angular/core";
import { IShoppingCartSnapshot_FE } from "@vierkant-software/types__api";
import { environment } from "src/environments/environment";

export enum ShoppingCartDetailLevel {
    default = 0,
}
interface IShoppingCartSimple {
  ID?: string;
  title?: string;
  created_at?: DateTime;
  modified_at?: DateTime;
  owner_ID?: string;
  snapshot?: IShoppingCartSnapshot_FE;
}

type ShoppingCartDetailType = {
    [ShoppingCartDetailLevel.default]: Partial<IShoppingCartSimple>;
};

@Injectable({ providedIn: "root" })
export class ShoppingCartSyncService extends FullSyncableServiceBase <ShoppingCartDetailType, ShoppingCartDetailLevel> {
    override getDefaultValue(): ShoppingCartDetailType[ShoppingCartDetailLevel] {
        return {} as ShoppingCartDetailType[ShoppingCartDetailLevel];
    }
    protected readonly syncName = "shoppingCartSync";
    protected override get usesDeviceSession(): boolean {
        return environment.isCashRegister;
    }
}